import {Component, Inject, Vue, Watch} from 'vue-property-decorator';
import RegistrationService from '@/apis/registration';
// @ts-ignore
import md5 from 'crypto-js/md5';
import {required, email, minLength} from 'vuelidate/lib/validators';
import AccountService from "@/components/account/account.service";

const validations = {
  newUser:{
    fullName: {required},
    address: {required},
    phoneNumber: { required, minLength: minLength(14) },
    email: {required,email},
    userName: {required},
    password: {required},
  }
}

@Component({
  components: {},
  validations
})
export default class RegistrationComponent extends Vue {

  @Inject('accountService') private accountService!: () => AccountService;
  @Inject('registrationService') private registrationService!: () => RegistrationService;

  public newUser = {
    phoneNumber: '',
    address: '',
    fullName: '',
    email: '',
    userName: '',
    password: '',
    lastName: '',
    firstName: '',
  };
  public succeed: boolean = false
  public errMsg: string = '';

  autocomplete = '';

  public async submit() {
    this.errMsg = '';
    this.$store.commit('setOverlay', true)
    let validateData = {
      securityToken: this.$store.getters.token,
      method: 13,
      userName: this.newUser.userName,
    }
    const validate = await this.registrationService().validateUserName(validateData)

    if ('errNo' in validate && validate.errNo !== 0) {
      let errMsg = 'errMsg' in validate ? validate.errMsg : 'Service is unavailable';
      if (validate.Errors && validate.Errors.length) {
        const [firstError] = validate.Errors;
        ({ errMsg } = firstError);
      }
      if(errMsg === 'User name already exists in the system.') {
        this.errMsg = errMsg;
        throw new Error(errMsg);
      }
    }

    let clientData = {
      securityToken: this.$store.getters.token,
      method: 3,
      Fields: [
        {
          fieldID: 1091, //Email
          fieldValue: this.newUser.email
        }, {
          fieldID: 112, // phone number
          fieldValue: this.newUser.phoneNumber.replace(/[\s\-\(\)]+/g , '')
        },
        {
          fieldID: 121,
          optionID: 59 // 59 - residential, 60 - commercial
        },
        {
          fieldID: 126, // account name (full name?)
          fieldValue: this.newUser.fullName
        },
        {
          fieldID: 129,
          fieldValue: this.newUser.address // main address
        },
      ]
    }
    const client = await this.registrationService().addClient(clientData)
    const contactData = {
      "securityToken": this.$store.getters.token,
      "method": "3",
      "clientID": client.Client.objectID,
      "Fields":
        [
          {
            "fieldID": 97,//email
            "fieldValue": this.newUser.email
          },
          {
            fieldID: 127,
            fieldValue: this.newUser.firstName ? this.newUser.firstName : '',
          },
          {
            fieldID: 128,
            fieldValue: this.newUser.lastName ? this.newUser.lastName : '',
          },
          {
            fieldID: 9795,
            fieldValue: this.newUser.fullName,
          },
          {
            "fieldID": 1088,//mobile phone
            "fieldValue": this.newUser.phoneNumber.replace(/[\s\-\(\)]+/g , '')
          }
        ]
    }
    const contact = await this.registrationService().addContact(contactData)
    const contactCredentialsData = {
      "securityToken": this.$store.getters.token,
      "method": "8",
      "objectID": contact.Contact.objectID,//
      "clientID": client.Client.objectID,
      "userName": this.newUser.userName,
      "password": (md5(this.newUser.password)).toString()
    }
    const credentials = await this.registrationService().setContactsSignInCredentials(contactCredentialsData)
    if (credentials.errNo!==0) {
      this.succeed = false;
      this.errMsg = credentials.errMsg;
      // @ts-ignore
      credentials.Errors.forEach( (err, index)=>{
        this.errMsg = `${this.errMsg}
${err.errMsg}`
      })
    } else {
      this.succeed = true;
      this.errMsg = '';
      // @ts-ignore
      const clientId = credentials.Relations.filter(relation=> relation.objectTypeID===7)[0].objectID;
      const contactId = credentials.Contact.objectID;
      const login = credentials.name;
		this.$store.commit('updateLogin', login);
      this.$store.commit('updateContactId', {contactId, clientId});
      this.clearFields();
      this.$emit('close-RegDialog');
    }
    this.$store.commit('setOverlay', false)
  }

  public close(){
    this.clearFields();
    this.$emit('close-RegDialog');
  }

  @Watch('newUser.fullName')
  watchFullName() {
    var fullName = this.newUser.fullName.split(' ')
    this.newUser.firstName = fullName[0]
    this.newUser.lastName = fullName[1];
  }

  public toAuth(){
    this.clearFields();
    this.$emit('toAuthorisation');
  }

  mounted(){
    let addressField = document.getElementById('autocompleteRegistration');
    //@ts-ignore
    this.autocomplete = new google.maps.places.Autocomplete(addressField, {
      componentRestrictions: { country: ["ca", "us"] },
      fields: ['formatted_address'],
      types: ["address"],
    });
    //@ts-ignore
    addressField.addEventListener('paste', (e)=> {

      //@ts-ignore
      const sessionToken = new google.maps.places.AutocompleteSessionToken();
      //@ts-ignore
      const servicePlace = new google.maps.places.PlacesService(document.getElementById('autocompleteRegistration'));
      //@ts-ignore
      const service = new google.maps.places.AutocompleteService();
      //@ts-ignore
      const textInput = e.clipboardData.getData('Text')
      if(textInput){

        const displaySuggestions = (predictions:any, status:any) => {
          //@ts-ignore
          if (status != google.maps.places.PlacesServiceStatus.OK || !predictions) {
            return;
          }

          if(predictions.length === 1){

            var request = {
              placeId: predictions[0].place_id,
              fields: ['formatted_address'],
              sessionToken: sessionToken
            };


            servicePlace.getDetails(request, (place:any, status:any) => {
              //@ts-ignore
              if (status == google.maps.places.PlacesServiceStatus.OK) {
                this.addressParse(place)
              }
            });
          }

        };

        service.getPlacePredictions({ input: textInput, sessionToken: sessionToken, componentRestrictions: { country: ["ca", "us"] },
          fields: ["address_components"],
          types: ["address"],  }, displaySuggestions);
      }
    });
    //@ts-ignore
    this.autocomplete.addListener("place_changed", this.fillInAddress);
  }

  fillInAddress() {
    //@ts-ignore
    const place = this.autocomplete.getPlace();
    this.addressParse(place)
  }

  addressParse(place:any){
    this.newUser.address = place.formatted_address
  }

  public clearFields(){
    this.newUser = {
      phoneNumber: "",
      address: '',
      fullName: '',
      email: '',
      userName: '',
      password: '',
      lastName: '',
      firstName: '',
    }
  this.succeed = false
  this.errMsg = '';
  }
}

